<template>
  <cg_mask class="auth_container">
    <div class="main">
      <div class="close_btn" @click="$emit('close')"></div>
      <p class="title">实名认证</p>
      <p class="sub_title">
        根据新闻出版署《关于防止未成年人沉迷网络游戏工作的通知》和《关于进一步严格管理切实防止未成年人沉迷网络游戏的通知》要求，请您使用真实信息进行实名认证。
      </p>
      <div class="input_wrap">
        <div class="prepend">姓名</div>
        <div class="line"></div>
        <input type="text" placeholder="请输入真实姓名" v-model="formInfo.real_name" />
      </div>
      <div class="input_wrap noMarginBottom">
        <div class="prepend">身份证</div>
        <div class="line"></div>
        <input type="text" placeholder="请输入有效的身份证号" v-model="formInfo.id_card" />
      </div>
      <div
        :class="{
          auth_btn: true,
          disabled: authBtnDisabled,
        }"
        @click="authByCard"
      >
        认证
      </div>
    </div>
  </cg_mask>
</template>
<script>
import { debounce } from '@plaformWeb/web-utils'

function validateID(id) {
  debugger
  if (!/^\d{17}[\dXx]$/.test(id)) {
    return false
  }

  const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
  const checkDigits = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']

  const sum = id
    .substr(0, 17)
    .split('')
    .reduce((acc, curr, index) => acc + curr * weights[index], 0)

  const checkDigit = checkDigits[sum % 11]

  return checkDigit === id[17].toUpperCase()
}

export default {
  data() {
    return {
      formInfo: {
        real_name: '',
        id_card: '',
      },
    }
  },
  computed: {
    authBtnDisabled() {
      return (
        !this.formInfo.real_name || !this.formInfo.id_card || !validateID(this.formInfo.id_card)
      )
    },
  },
  beforeDestroy() {},
  methods: {
    authByCard: debounce(function () {
      if (!this.formInfo.real_name) {
        return this.$toast('请输入姓名')
      }

      if (!this.formInfo.id_card) {
        return this.$toast('请输入证件号码')
      }

      if (!validateID(this.formInfo.id_card)) {
        return this.$toast('请输入有效的证件号码')
      }
      this.$emit('confirm', this.formInfo)
    }, 500),
  },
}
</script>
<style scoped lang="less">
@import '../assets/css/zIndex.less';

.auth_container {
  .main {
    position: relative;
    width: 490px;
    background: #fff;
    border-radius: 16px;
    padding: 36px 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    .close_btn {
      position: absolute;
      width: 35px;
      height: 35px;
      top: 16px;
      right: 16px;
      cursor: pointer;
      transform: scale(0.8);
      &::before,
      &::after {
        position: absolute;
        content: '';
        display: block;
        height: 5px;
        width: 42px;
        background: #808080;
        border-radius: 5px;
      }
      &::before {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
      }
      &::after {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(-45deg);
      }
    }
    .title {
      margin-bottom: 30px;
      font-size: 27px;
      color: #202226;
    }
    .sub_title {
      margin-bottom: 20px;
      font-size: 15px;
      line-height: 25px;
      color: #202226;
    }
    .input_wrap {
      position: relative;
      width: 100%;
      font-size: 0;
      display: flex;
      align-items: center;
      height: 46px;
      margin-bottom: 20px;
      background: #f4f4f4;
      border-radius: 10px;
      border: 2px solid #eae9e9;
      &.noMarginBottom {
        margin-bottom: 0;
      }
      input {
        flex-grow: 1;
        border: none;
        outline: none;
        background: transparent;
        padding-left: 12px;
        font-size: 17px;
        color: #202226;
        &::placeholder {
          color: #b2afaf;
        }
        &:focus {
          outline: none;
          background-color: transparent;
        }
      }
      .line {
        background: #d0cdcd;
        height: 21px;
        width: 1px;
      }
      .prepend {
        text-align: center;
        width: 64px;
        font-size: 17px;
        color: #202226;
      }
    }
    .auth_btn {
      margin-top: 20px;
      width: 100%;
      height: 53px;
      background: #07c261;
      border-radius: 10px;
      font-size: 22px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &.disabled {
        background: #c5c5c5;
        cursor: not-allowed;
      }
    }
  }
}
@media (max-width: 1024px) {
  .auth_container {
    .main {
      width: 6rem;
      border-radius: 0.16rem;
      padding: 0.48rem;
      .close_btn {
        width: 0.35rem;
        height: 0.35rem;
        top: 0.16rem;
        right: 0.16rem;
        transform: scale(0.8);
        &::before,
        &::after {
          height: 0.05rem;
          width: 0.42rem;
          border-radius: 0.05rem;
        }
      }
      .title {
        margin-bottom: 0.44rem;
        font-size: 0.38rem;
      }
      .sub_title {
        margin-bottom: 0.16rem;
        font-size: 0.22rem;
        line-height: 0.38rem;
      }
      .input_wrap {
        height: 0.66rem;
        margin-bottom: 0.27rem;
        border-radius: 0.1rem;
        border: 1px solid #eae9e9;
        input {
          padding-left: 0.12rem;
          font-size: 0.24rem;
        }
        .line {
          height: 0.21rem;
          width: 1px;
        }
        .prepend {
          width: 0.86rem;
          font-size: 0.24rem;
        }
      }
      .auth_btn {
        margin-top: 0.2rem;
        height: 0.75rem;
        border-radius: 0.1rem;
        font-size: 0.32rem;
      }
    }
  }
}
</style>
